import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  useProfileCompanyLogoDeleteMutation,
  useProfileCompanyLogoUploadMutation,
} from '@/features/profile/store'
import { useNotify } from '@/hooks'

export const useCompanyLogoManager = () => {
  const { t } = useTranslation()

  const { showNotification } = useNotify()

  const [logoUpload, { isLoading: uploading }] = useProfileCompanyLogoUploadMutation()

  const onUpload = async (file: File) => {
    try {
      const data = {
        logo: file,
      }

      await logoUpload(data).unwrap()

      showNotification({
        type: 'success',
        message: t('saved_successfully'),
      })
    } catch (error: any) {
      const message = error?.data?.message || t('error')
      showNotification({ type: 'error', message: message })
    }
  }

  const [logoRemove, { isLoading: removing }] = useProfileCompanyLogoDeleteMutation()

  const onRemove = async () => {
    try {
      await logoRemove().unwrap()

      showNotification({
        type: 'success',
        message: t('deleted_successfully'),
      })
    } catch (error: any) {
      const message = error?.data?.message || t('error')
      showNotification({ type: 'error', message: message })
    }
  }

  return {
    uploading,
    onUpload,
    removing,
    onRemove,
  }
}
